import { createFileRoute, redirect } from "@tanstack/react-router";
import { setPendingModal } from "../../../libs/pending-modal";

export const Route = createFileRoute("/_authed/sd/$distributionCode")({
  loader: async ({ params: { distributionCode } }) => {
    const data: StandaloneDistributionCodeModalState = {
      type: "standalone-distribution-code",
      data: { distributionCode },
    };
    setPendingModal(data);

    return redirect({ to: "/", replace: true });
  },
});
